module.exports = __webpack_public_path__ + "static/media/riskpic2.5d42d0b9.png";